"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowMetaModelRegistry = void 0;
const Event_1 = __importDefault(require("@opsbase/lib-event/Event"));
const actionsFor_1 = __importDefault(require("../../WorkflowAction/actionsFor"));
const queryFieldsFor_1 = require("../../WorkflowCondition/queryFieldsFor");
exports.WorkflowMetaModelRegistry = {
    [Event_1.default.SENSOR_READING]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.SENSOR_READING),
        actions: (0, actionsFor_1.default)(Event_1.default.SENSOR_READING),
    },
    [Event_1.default.SCHEDULE]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.SCHEDULE),
        actions: (0, actionsFor_1.default)(Event_1.default.SCHEDULE),
    },
    [Event_1.default.ISSUE_CREATED]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.ISSUE_CREATED),
        actions: (0, actionsFor_1.default)(Event_1.default.ISSUE_CREATED),
    },
    [Event_1.default.ISSUE_ASSIGNED]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.ISSUE_ASSIGNED),
        actions: (0, actionsFor_1.default)(Event_1.default.ISSUE_ASSIGNED),
    },
    [Event_1.default.ISSUE_COMMENT]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.ISSUE_COMMENT),
        actions: (0, actionsFor_1.default)(Event_1.default.ISSUE_COMMENT),
    },
    [Event_1.default.ISSUE_STATUS_CHANGED]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.ISSUE_STATUS_CHANGED),
        actions: (0, actionsFor_1.default)(Event_1.default.ISSUE_STATUS_CHANGED),
    },
    [Event_1.default.ISSUE_CLOSED]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.ISSUE_CLOSED),
        actions: (0, actionsFor_1.default)(Event_1.default.ISSUE_CLOSED),
    },
    [Event_1.default.ISSUE_MISSED]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.ISSUE_MISSED),
        actions: (0, actionsFor_1.default)(Event_1.default.ISSUE_MISSED),
    },
    [Event_1.default.OP_DUE]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.OP_DUE),
        actions: (0, actionsFor_1.default)(Event_1.default.OP_DUE),
    },
    [Event_1.default.OP_LATE]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.OP_LATE),
        actions: (0, actionsFor_1.default)(Event_1.default.OP_LATE),
    },
    [Event_1.default.OP_MISSED]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.OP_MISSED),
        actions: (0, actionsFor_1.default)(Event_1.default.OP_MISSED),
    },
    [Event_1.default.OP_COMPLETE]: {
        queryFields: (0, queryFieldsFor_1.queryFieldsfor)(Event_1.default.OP_COMPLETE),
        actions: (0, actionsFor_1.default)(Event_1.default.OP_COMPLETE),
    },
};
exports.default = exports.WorkflowMetaModelRegistry;
